import { hasParticipantFilterActive } from 'common-data-handling';

/**
 * Determines if the suggested participants tab is visible based on the given suggested filter parameters.
 *
 * @param {Object} suggestedFilterParams - The suggested filter parameters.
 * @return {boolean} True if the suggested participants tab is visible, false otherwise.
 */
export function isSuggestedParticipantsTabVisible(suggestedFilterParams) {
    return hasParticipantFilterActive(suggestedFilterParams);
}
